import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@neo/primitives/accordion'
import { Button } from '@neo/primitives/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@neo/primitives/dialog'
import { Expand } from 'lucide-react'
import type { KBChunk } from '../types'

export const KbMetrics = ({ chunks }: { chunks: KBChunk[] }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="iconXs"
          className="shrink-0 text-secondary"
          aria-label="View retrieved chunks"
          data-testid="button-expand-kb-chunks"
        >
          <Expand className="h-3 w-3" />
        </Button>
      </DialogTrigger>
      <DialogContent
        className="w-[calc(100vw-2rem)] max-w-4xl max-h-[80vh] overflow-hidden"
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-h3-500 text-foreground">
            Retrieved Chunks{' '}
            <span className="font-jetbrains text-xs-400 tabular-nums">({chunks.length})</span>
          </DialogTitle>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto">
          <div className="space-y-3">
            <Accordion type="single" collapsible className="w-full space-y-2">
              {chunks.map((chunk, index) => (
                <AccordionItem
                  key={`chunk-${index}`}
                  value={`chunk-${index}`}
                  className="group rounded-lg border border-border bg-card transition-colors"
                >
                  <AccordionTrigger
                    className="text-s-500 px-4 py-3 hover:no-underline transition-colors data-[state=open]:pb-3 !justify-start"
                    data-testid={`button-kb-chunk-${index + 1}`}
                  >
                    <div className="flex flex-col items-start gap-3 w-0 flex-1">
                      <div className="text-h4-500 shrink-0">
                        Chunk{' '}
                        <span className="font-jetbrains text-xs-400 tabular-nums">{index + 1}</span>
                      </div>
                      <div className="font-inter text-s-400 text-secondary text-left truncate w-full group-data-[state=open]:hidden">
                        {chunk.content}
                      </div>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="border-t border-border p-4">
                    <div>
                      <div className="font-inter text-s-400 text-primary whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
                        {chunk.content}
                      </div>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button data-testid="button-close-dialog">Close</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
